<template>
  <div class="home">
    <!-- Primary Page Layout
    ==================================================-->

    <div class="section background-dark over-hide">
      <div class="hero-center-section">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-10 col-sm-8 parallax-fade-top">
              <div class="hero-text" style="margin-top: 60px">Welcome To Ogeyi Place Hotel</div>
            </div>
            <div class="col-12 mt-3 mb-5 parallax-fade-top">
              <div class="hero-stars">
                <i class="fa fa-star-o"></i>
                <i class="fa fa-star-o"></i>
                <i class="fa fa-star-o"></i>
                <i class="fa fa-star-o"></i>
                <i class="fa fa-star-o"></i>
              </div>
            </div>
            <div class="col-12 mt-3 parallax-fade-top">
              <div class="booking-hero-wrap">
                <div class="row justify-content-center">
                  <div class="col-5 no-mob">
                    <div class="input-daterange input-group" id="flight-datepicker">
                      <div class="row">
                        <div class="col-6">
                          <div class="form-item">
                            <span class="fontawesome-calendar"></span>
                            <input
                              class="input-sm"
                              type="text"
                              autocomplete="off"
                              id="start-date-1"
                              name="start"
                              placeholder="chech-in date"
                              data-date-format="DD, MM d"
                            >
                            <span class="date-text date-depart"></span>
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="form-item">
                            <span class="fontawesome-calendar"></span>
                            <input
                              class="input-sm"
                              type="text"
                              autocomplete="off"
                              id="end-date-1"
                              name="end"
                              placeholder="check-out date"
                              data-date-format="DD, MM d"
                            >
                            <span class="date-text date-return"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-5 no-mob">
                    <div class="row">
                      <div class="col-6">
                        <select name="adults" class="wide" id="adults">
                          <option data-display="guests" value="0">Guests</option>
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                          <option value="5">5</option>
                        </select>
                      </div>
                      <!-- <div class="col-6">
                        <select name="children" class="wide" id="children">
                          <option data-display="children" value="0">children</option>
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                          <option value="5">5</option>
                        </select>
                      </div> -->
                       <div class="col-6 col-sm-6 col-lg-6">

                    <a
                      class="booking-button"
                      href="#/search"
                      @click="checkAvailabilty($event)"
                    >Check Availabilty</a>
                  </div>
                    </div>
                  </div>
                  <!-- <div class="col-6 col-sm-4 col-lg-2">

                    <a
                      class="booking-button"
                      href="#/search"
                      @click="checkAvailabilty($event)"
                    >book now</a>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="slideshow">
        <div class="slide slide--current parallax-top">
          <figure class="slide__figure">
            <div class="slide__figure-inner">
              <div class="slide__figure-img" style="background-image: url(img/activities.jpg)"></div>
              <div class="slide__figure-reveal"></div>
            </div>
          </figure>
        </div>
        <div class="slide parallax-top">
          <figure class="slide__figure">
            <div class="slide__figure-inner">
              <div class="slide__figure-img" style="background-image: url(img/room.jpg)"></div>
              <div class="slide__figure-reveal"></div>
            </div>
          </figure>
        </div>
        <div class="slide parallax-top">
          <figure class="slide__figure">
            <div class="slide__figure-inner">
              <div class="slide__figure-img" style="background-image: url(img/resturant.jpg)"></div>
              <div class="slide__figure-reveal"></div>
            </div>
          </figure>
        </div>
        <!-- revealer -->
        <div class="revealer">
          <div class="revealer__item revealer__item--left"></div>
          <div class="revealer__item revealer__item--right"></div>
        </div>
        <nav class="arrow-nav fade-top">
          <button class="arrow-nav__item arrow-nav__item--prev">
            <svg class="icon icon--nav">
              <use xlink:href="#icon-nav"></use>
            </svg>
          </button>
          <button class="arrow-nav__item arrow-nav__item--next">
            <svg class="icon icon--nav">
              <use xlink:href="#icon-nav"></use>
            </svg>
          </button>
        </nav>
        <!-- navigation -->
        <nav class="nav fade-top">
          <button class="nav__button">
            <span class="nav__button-text"></span>
          </button>
          <h2 class="nav__chapter">discover your paradise</h2>
          <div class="toc">
            <a class="toc__item" href="#entry-1">
              <span class="toc__item-title">discover your paradise</span>
            </a>
            <a class="toc__item" href="#entry-2">
              <span class="toc__item-title">unpretentious comfort</span>
            </a>
            <a class="toc__item" href="#entry-3">
              <span class="toc__item-title">azure sea sparkling</span>
            </a>
          </div>
        </nav>
        <!-- little sides -->
        <div class="slideshow__indicator"></div>
        <div class="slideshow__indicator"></div>
      </div>
    </div>

    <div class="section padding-top-bottom over-hide">
      <div class="container">
        <div class="row">
          <div class="col-md-6 align-self-center">
            <div class="row justify-content-center">
              <div class="col-10">
                <div class="subtitle text-center mb-4">Ogeyi Place Hotel</div>
                <h2 class="text-center">Who We Are</h2>
                <p
                  class="text-center mt-5"
                >Ogeyi Place Hotel is a 4-Star hotel situated at the popular GRA Phase 2 area of Port Harcourt, at 45 Tombia Street GRA Phase II Port Harcourt, Rivers State, Nigeria. With 86 luxury and tastily furnished deluxe rooms, the hotel offers a splendid view of Port Harcourt city; most importantly, it is a few steps away from the Polo Club and about 16 miles from the Port Harcourt International Airport. This is the right location for you ours guest to enjoy your stay. We get you served with mouth-watering Nigerian and International buffet, à la carte menu and a selection of beverages at our Ororo Restaurant and bar.</p>
              </div>
            </div>
          </div>
          <div class="col-md-6 mt-4 mt-md-0">

            <div id="owl-sep-20" class="owl-carousel owl-theme" style="margin-top: 72px">
              <div class="item">
                <a href="img/frame_0.jpg" data-fancybox="gallery">
                  <div class="img-wrap">
                    <img src="img/frame_0.jpg" alt>
                  </div>
                </a>
              </div>
              <div class="item">
                <a href="img/luxury_service.jpg" data-fancybox="gallery">
                  <div class="img-wrap">
                    <img src="img/luxury_service.jpg" alt>
                  </div>
                </a>
              </div>
              <div class="item">
                <a href="img/frame_2.jpg" data-fancybox="gallery">
                  <div class="img-wrap">
                    <img src="img/frame_2.jpg" alt>
                  </div>
                </a>
              </div>
              <div class="item">
                <a href="img/frame_3.jpg" data-fancybox="gallery">
                  <div class="img-wrap">
                    <img src="img/frame_3.jpg" alt>
                  </div>
                </a>
              </div>
            </div>
            <!-- <div class="img-wrap" >
              <img src="img/montage.png" alt>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <div class="section background-grey over-hide">
      <div class="container-fluid px-0">
        <div class="row mx-0">
          <div class="col-xl-6 px-0">
            <div class="img-wrap" id="rev-1">
              <img src="img/gym-center.jpg" alt>
              <div class="text-element-over">Gym, Spa, Pool, Polo</div>
            </div>
          </div>
          <div class="col-xl-6 px-0 mt-4 mt-xl-0 pb-5 pb-xl-0 align-self-center">
            <div class="row justify-content-center">
              <div class="col-10 col-xl-8 text-center">
                <h3 class="text-center">Gym, Spa, Pool, Polo</h3>
                <p
                  class="text-center mt-4"
                >State of the art gym, Spa, Polo side Pool helps you rejuvenate during your endless business schedule.</p>
                <a class="mt-5 btn btn-primary" href="#/search" @click="bookNow($event)">Book Now</a>
              </div>
            </div>
          </div>
        </div>
        <div class="row mx-0">
          <div class="col-xl-6 px-0 mt-4 mt-xl-0 pb-5 pb-xl-0 align-self-center">
            <div class="row justify-content-center">
              <div class="col-10 col-xl-8 text-center">
                <h3 class="text-center">Luxury Service</h3>
                <p
                  class="text-center mt-4"
                >Thoughtful luxury and personalized service awaits in each of our 86 Deluxe rooms and suites with stunning views of either the Polo club or the Port Harcourt urban View.</p>
                <a class="mt-5 btn btn-primary" href="#/search">check availability</a>
              </div>
            </div>
          </div>
          <div class="col-xl-6 px-0 order-first order-xl-last mt-5 mt-xl-0">
            <div class="img-wrap" id="rev-2">
              <img src="img/luxury_service.jpg" alt>
              <div class="text-element-over">Personalised Luxuy</div>
            </div>
          </div>
        </div>

        <div class="row mx-0">
          <div class="col-xl-6 px-0 mt-5 mt-xl-0">
            <div class="img-wrap" id="rev-2">
              <img src="img/restaurant-view-one.jpg" alt>
              <div class="text-element-over">Stylish Cuisines</div>
            </div>
          </div>
          <div class="col-xl-6 px-0 mt-4 mt-xl-0 pb-5 pb-xl-0 align-self-center">
            <div class="row justify-content-center">
              <div class="col-10 col-xl-8 text-center">
                <h3 class="text-center">Stylish Cuisines</h3>
                <p
                  class="text-center mt-4"
                >Stylish Ororo restaurant and bar located on the Ground floor. Guests enjoy traditional and intercontinental cuisine and a wide selection of wines with authentic hospitality.</p>
              </div>
            </div>
          </div>
        </div>

        <div class="row mx-0">
          <div class="col-xl-6 px-0 mt-4 mt-xl-0 pb-5 pb-xl-0 align-self-center">
            <div class="row justify-content-center">
              <div class="col-10 col-xl-8 text-center">
                <h3 class="text-center">Event Venues</h3>
                <p
                  class="text-center mt-4"
                >Plan your next events and meetings with us. Our meeting venues are equipped with state-of-the-art facilities and a dedicated planning team.</p>
              </div>
            </div>
          </div>
          <div class="col-xl-6 px-0 order-first order-xl-last mt-5 mt-xl-0">
            <div class="img-wrap" id="rev-2">
              <img src="img/activities.jpg" alt>
              <div class="text-element-over">Personalised Luxuy</div>
            </div>
          </div>
        </div>

        <div class="row mx-0">
          <div class="col-xl-6 px-0 mt-5 mt-xl-0">
            <div class="img-wrap" id="rev-2">
              <img src="img/hotel-side-view.jpg" alt>
              <div class="text-element-over">Perfectly Located</div>
            </div>
          </div>
          <div class="col-xl-6 px-0 mt-4 mt-xl-0 pb-5 pb-xl-0 align-self-center">
            <div class="row justify-content-center">
              <div class="col-10 col-xl-8 text-center">
                <h3 class="text-center">Perfectly Located</h3>
                <p
                  class="text-center mt-4"
                >Perfectly located at GRA Phase 2, within the heart of the Central Business District and major leisure centers.</p>
                <a class="mt-5 btn btn-primary" href="#/search">check availability</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section background-dark over-hide">
      <div class="container-fluid py-4">
        <div class="row">
          <div class="col-sm-6 col-lg-3">
            <a href="#">
              <div class="img-wrap services-wrap">
                <img src="img/gym.jpg" alt>
                <div class="services-text-over">Gym</div>
              </div>
            </a>
          </div>
          <div class="col-sm-6 col-lg-3 pt-4 pt-sm-0">
            <a href="#">
              <div class="img-wrap services-wrap">
                <img src="img/resturant.jpg" alt>
                <div class="services-text-over">restaurant</div>
              </div>
            </a>
          </div>
          <div class="col-sm-6 col-lg-3 pt-4 pt-lg-0">
            <a href="#">
              <div class="img-wrap services-wrap">
                <img src="img/pool.jpg" alt>
                <div class="services-text-over">pool</div>
              </div>
            </a>
          </div>
          <div class="col-sm-6 col-lg-3 pt-4 pt-lg-0">
            <a href="#">
              <div class="img-wrap services-wrap">
                <img src="img/activities-2.jpg" alt>
                <div class="services-text-over">activities</div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="section padding-top-bottom over-hide">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-8 align-self-center">
            <div class="subtitle with-line text-center mb-4">elegant suites</div>
            <h3 class="text-center padding-bottom-small">Unpretentious luxury</h3>
          </div>
          <div class="section clearfix"></div>
          <div class="col-sm-6 col-lg-4">
            <div class="services-box text-center">
              <img src="img/1.svg" alt>
              <h5 class="mt-2">smoking free</h5>
              <!-- <p class="mt-3">
                Sed ut perspiciatis unde omnis iste natus error sit, totam rem aperiam, eaque
                ipsa quae ab illo inventore veritatis et.
              </p>-->
            </div>
          </div>
          <div class="col-sm-6 col-lg-4 mt-5 mt-sm-0">
            <div class="services-box text-center">
              <img src="img/2.svg" alt>
              <h5 class="mt-2">king beds</h5>
              <!-- <p class="mt-3">
                Sed ut perspiciatis unde omnis iste natus error sit, totam rem aperiam, eaque
                ipsa quae ab illo inventore veritatis et.
              </p>-->
            </div>
          </div>
          <div class="col-sm-6 col-lg-4 mt-5 mt-lg-0">
            <div class="services-box text-center">
              <img src="img/3.svg" alt>
              <h5 class="mt-2">Event hall</h5>
              <!-- <p class="mt-3">
                Sed ut perspiciatis unde omnis iste natus error sit, totam rem aperiam, eaque
                ipsa quae ab illo inventore veritatis et.
              </p>-->
            </div>
          </div>
          <div class="col-sm-6 col-lg-4 mt-5">
            <div class="services-box text-center">
              <img src="img/4.svg" alt>
              <h5 class="mt-2">welcome drink</h5>
              <!-- <p class="mt-3">
                Sed ut perspiciatis unde omnis iste natus error sit, totam rem aperiam, eaque
                ipsa quae ab illo inventore veritatis et.
              </p>-->
            </div>
          </div>
          <div class="col-sm-6 col-lg-4 mt-5">
            <div class="services-box text-center">
              <img src="img/5.svg" alt>
              <h5 class="mt-2">swimming pool</h5>
              <!-- <p class="mt-3">
                Sed ut perspiciatis unde omnis iste natus error sit, totam rem aperiam, eaque
                ipsa quae ab illo inventore veritatis et.
              </p>-->
            </div>
          </div>
          <div class="col-sm-6 col-lg-4 mt-5">
            <div class="services-box text-center">
              <img src="img/6.svg" alt>
              <h5 class="mt-2">food included</h5>
              <!-- <p class="mt-3">
                Sed ut perspiciatis unde omnis iste natus error sit, totam rem aperiam, eaque
                ipsa quae ab illo inventore veritatis et.
              </p>-->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section padding-top-bottom-big over-hide">
      <div class="parallax" style="background-image: url('img/activities-2.jpg')"></div>
      <div class="section z-bigger">
        <div class="container">
          <div class="booking-hero-wrap">
            <div class="row justify-content-center">
              <div class="col-5 no-mob">
                <div class="input-daterange input-group" id="flight-datepicker">
                  <div class="row">
                    <div class="col-6">
                      <div class="form-item">
                        <span class="fontawesome-calendar"></span>
                        <input
                          class="input-sm"
                          type="text"
                          autocomplete="off"
                          id="start-date"
                          name="start"
                          placeholder="chech-in date"
                          data-date-format="DD, MM d"
                          v-model="startDate"
                        >
                        <span class="date-text date-depart"></span>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="form-item">
                        <span class="fontawesome-calendar"></span>
                        <input
                          class="input-sm"
                          type="text"
                          autocomplete="off"
                          id="end-date"
                          name="end"
                          placeholder="check-out date"
                          data-date-format="DD, MM d"
                          v-model="endDate"
                        >
                        <span class="date-text date-return"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-5 no-mob">
                <div class="row">
                  <div class="col-6">
                    <select name="adults" class="wide">
                      <option data-display="adults">adults</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                    </select>
                  </div>
                  <div class="col-6">
                    <select name="children" class="wide">
                      <option data-display="children">children</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-6 col-sm-4 col-lg-2">
                <a
                  class="booking-button"
                  href="#/search"
                  @click="bookNow($event)"
                >book now</a>
                <!-- <a
                  class="booking-button"
                  href="#/search"
                  @click="checkAvailabilty($event, true)"
                >book now</a> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section padding-top-bottom over-hide background-grey">
      <div class="container">
        <div class="row justify-content-center">
          <rooms-section></rooms-section>
        </div>
      </div>
    </div>

    <div class="section padding-top-bottom-big over-hide">
      <div class="parallax" style="background-image: url('img/room.jpg')"></div>
      <div class="section z-bigger">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-md-8">
              <div id="owl-sep-1" class="owl-carousel owl-theme">
                <div class="item">
                  <div class="quote-sep">
                    <h4>
                      "Chilling out on the bed in your hotel room watching television, while wearing
                      your own pajamas, is sometimes the best part of a vacation."
                    </h4>
                    <h6>Jason Salvatore</h6>
                  </div>
                </div>
                <div class="item">
                  <div class="quote-sep">
                    <h4>
                      "Every good day starts off with a cappuccino, and there's no place better to
                      enjoy some frothy caffeine than at the Thalia Hotel."
                    </h4>
                    <h6>Terry Mitchell</h6>
                  </div>
                </div>
                <div class="item">
                  <div class="quote-sep">
                    <h4>
                      "I still enjoy traveling a lot. I mean, it amazes me that I still get excited in
                      hotel rooms just to see what kind of shampoo they've left me."
                    </h4>
                    <h6>Michael Brighton</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section padding-top-bottom-small background-dark-2 over-hide">
      <div class="container">
        <div class="row">
          <div class="col-md-12 text-center">
            <h5 class="color-grey">A new dimension of luxury.</h5>
            <p class="color-white mt-3 mb-3">
              <em>our presentation, 0:48 min</em>
            </p>
            <a href="https://vimeo.com/332409817" class="video-button" data-fancybox>
              <i class="fa fa-play"></i>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="section padding-top z-bigger">
      <div class="container">
        <div class="row justify-content-center padding-bottom-smaller">
          <div class="col-md-8">
            <div class="subtitle with-line text-center mb-4">get in touch</div>
            <h3 class="text-center padding-bottom-small">drop us a line</h3>
          </div>
          <div class="section clearfix"></div>
          <div class="col-md-6 col-lg-4">
            <div class="address">
              <div class="address-in text-left">
                <p class="color-black">Address:</p>
              </div>
              <div class="address-in text-right">
                <p>Avenue Str. 328</p>
              </div>
            </div>
            <div class="address">
              <div class="address-in text-left">
                <p class="color-black">City:</p>
              </div>
              <div class="address-in text-right">
                <p>Thessaloniki</p>
              </div>
            </div>
            <div class="address">
              <div class="address-in text-left">
                <p class="color-black">Check-In:</p>
              </div>
              <div class="address-in text-right">
                <p>14:00 pm</p>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4">
            <div class="address">
              <div class="address-in text-left">
                <p class="color-black">Phone:</p>
              </div>
              <div class="address-in text-right">
                <p>+234 02084 461770</p>
              </div>
            </div>
            <div class="address">
              <div class="address-in text-left">
                <p class="color-black">Email:</p>
              </div>
              <div class="address-in text-right">
                <p>reservations@ogeyiplace.com</p>
              </div>
            </div>
            <div class="address">
              <div class="address-in text-left">
                <p class="color-black">Check-Out:</p>
              </div>
              <div class="address-in text-right">
                <p>11:00 am</p>
              </div>
            </div>
          </div>
          <div class="section clearfix"></div>
          <div
            class="col-md-8 text-center mt-5"
            data-scroll-reveal="enter bottom move 50px over 0.7s after 0.2s"
          >
            <p class="mb-0">
              <em>available at: 8am - 10pm</em>
            </p>
            <h2 class="text-opacity">+21 60 374 7537</h2>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-md-8">
            <div class="subscribe-home">
              <input type="text" placeholder="your email here">
              <button data-lang="en">subscribe</button>
            </div>
          </div>
        </div>
      </div>
    </div>-->

    <div class="section">
      <div id="owl-sep-2" class="owl-carousel owl-theme">
        <div class="item">
          <a href="img/gallery-images/1.jpg" data-fancybox="gallery">
            <div class="img-wrap gallery-small">
              <img src="img/gallery-images/1.jpg" alt>
            </div>
          </a>
        </div>
        <div class="item">
          <a href="img/gallery-images/2.jpg" data-fancybox="gallery">
            <div class="img-wrap gallery-small">
              <img src="img/gallery-images/2.jpg" alt>
            </div>
          </a>
        </div>
        <div class="item">
          <a href="img/gallery-images/3.jpg" data-fancybox="gallery">
            <div class="img-wrap gallery-small">
              <img src="img/gallery-images/3.jpg" alt>
            </div>
          </a>
        </div>
        <div class="item">
          <a href="img/gallery-images/4.jpg" data-fancybox="gallery">
            <div class="img-wrap gallery-small">
              <img src="img/gallery-images/4.jpg" alt>
            </div>
          </a>
        </div>
        <div class="item">
          <a href="img/gallery-images/5.jpg" data-fancybox="gallery">
            <div class="img-wrap gallery-small">
              <img src="img/gallery-images/5.jpg" alt>
            </div>
          </a>
        </div>
        <div class="item">
          <a href="img/gallery-images/6.jpg" data-fancybox="gallery">
            <div class="img-wrap gallery-small">
              <img src="img/gallery-images/6.jpg" alt>
            </div>
          </a>
        </div>
        <div class="item">
          <a href="img/gallery-images/7.jpg" data-fancybox="gallery">
            <div class="img-wrap gallery-small">
              <img src="img/gallery-images/7.jpg" alt>
            </div>
          </a>
        </div>
        <div class="item">
          <a href="img/gallery-images/8.jpg" data-fancybox="gallery">
            <div class="img-wrap gallery-small">
              <img src="img/gallery-images/8.jpg" alt>
            </div>
          </a>
        </div>
        <div class="item">
          <a href="img/gallery-images/9.jpg" data-fancybox="gallery">
            <div class="img-wrap gallery-small">
              <img src="img/gallery-images/9.jpg" alt>
            </div>
          </a>
        </div>
        <div class="item">
          <a href="img/gallery-images/10.jpg" data-fancybox="gallery">
            <div class="img-wrap gallery-small">
              <img src="img/gallery-images/10.jpg" alt>
            </div>
          </a>
        </div>
        <div class="item">
          <a href="img/gallery-images/1.jpg" data-fancybox="gallery">
            <div class="img-wrap gallery-small">
              <img src="img/gallery-images/1.jpg" alt>
            </div>
          </a>
        </div>
        <div class="item">
          <a href="img/gallery-images/2.jpg" data-fancybox="gallery">
            <div class="img-wrap gallery-small">
              <img src="img/gallery-images/2.jpg" alt>
            </div>
          </a>
        </div>
        <div class="item">
          <a href="img/gallery-images/3.jpg" data-fancybox="gallery">
            <div class="img-wrap gallery-small">
              <img src="img/gallery-images/3.jpg" alt>
            </div>
          </a>
        </div>
        <div class="item">
          <a href="img/gallery-images/4.jpg" data-fancybox="gallery">
            <div class="img-wrap gallery-small">
              <img src="img/gallery-images/4.jpg" alt>
            </div>
          </a>
        </div>
        <div class="item">
          <a href="img/gallery-images/5.jpg" data-fancybox="gallery">
            <div class="img-wrap gallery-small">
              <img src="img/gallery-images/5.jpg" alt>
            </div>
          </a>
        </div>
      </div>
      <div class="loader" v-if="loader">
        <div class="loader__figure"></div>
      </div>
    </div>
  </div>

</template>

<script>
// var plugins = require("../../public/js/plugins.js");
import Constants from "@/common/Constants.js";
import roomsSection from "@/components/rooms-section.vue";

export default {
  components: {
    roomsSection
  },
  name: "home",
  data() {
    return {
      userQuery: {
        checkIn: "",
        checkOut: "",
        adults: 0,
        children: 0,
        guests: 0
      },
      loader:false,
      endDate: "",
      startDate: "",
      maxGuests: 0
    };
  },
  mounted() {
    this.initInputs();
  },
  methods: {
    initInputs() {
      //Input number
      jQuery(
        '<div class="quantity-nav"><div class="quantity-button quantity-up"></div><div class="quantity-button quantity-down"></div></div>'
      ).insertAfter(".quantity input");
      jQuery(".quantity").each(function() {
        var spinner = jQuery(this),
          input = spinner.find('input[type="number"]'),
          btnUp = spinner.find(".quantity-up"),
          btnDown = spinner.find(".quantity-down"),
          min = input.attr("min"),
          max = input.attr("max");

        btnUp.on("click", function() {
          var oldValue = parseFloat(input.val());
          if (oldValue >= max) {
            var newVal = oldValue;
          } else {
            var newVal = oldValue + 1;
          }
          spinner.find("input").val(newVal);
          spinner.find("input").trigger("change");
        });

        btnDown.on("click", function() {
          var oldValue = parseFloat(input.val());
          if (oldValue <= min) {
            var newVal = oldValue;
          } else {
            var newVal = oldValue - 1;
          }
          spinner.find("input").val(newVal);
          spinner.find("input").trigger("change");
        });
      });

      //Date Picker
      var dateSelect = $("#flight-datepicker");
      var dateDepart = $("#start-date");
      var dateReturn = $("#end-date");
      var spanDepart = $(".date-depart");
      var spanReturn = $(".date-return");
      var spanDateFormat = "ddd, MMMM D yyyy";

      dateSelect.datepicker({
        autoclose: true,
        format: "yyyy-mm-dd",
        maxViewMode: 0,
        startDate: "now"
      });

      //Date Picker

      var dateSelect = $("#flight-datepicker-1");
      var dateDepart = $("#start-date-1");
      var dateReturn = $("#end-date-1");
      var spanDepart = $(".date-depart");
      var spanReturn = $(".date-return");
      var spanDateFormat = "ddd, MMMM D yyyy";

      dateSelect.datepicker({
        autoclose: true,
        format: "yyyy-mm-dd",
        maxViewMode: 0,
        startDate: "now"
      });

      //Scroll back to top

      var offset = 300;
      var duration = 400;
      jQuery(window).on("scroll", function() {
        if (jQuery(this).scrollTop() > offset) {
          jQuery(".scroll-to-top").fadeIn(duration);
        } else {
          jQuery(".scroll-to-top").fadeOut(duration);
        }
      });

      jQuery(".scroll-to-top").on("click", function(event) {
        event.preventDefault();
        jQuery("html, body").animate(
          {
            scrollTop: 0
          },
          duration
        );
        return false;
      });

      //Navigation

      ("use strict");

      $(".menu > ul > li:has( > ul)").addClass("menu-dropdown-icon");
      //Checks if li has sub (ul) and adds class for toggle icon - just an UI

      $(".menu > ul > li > ul:not(:has(ul))").addClass("normal-sub");
      //Checks if drodown menu's li elements have anothere level (ul), if not the dropdown is shown as regular dropdown, not a mega menu (thanks Luka Kladaric)

     //$(".menu > ul").before('<a href="#" class="menu-mobile"></a>');

      //Adds menu-mobile class (for mobile toggle menu) before the normal menu
      //Mobile menu is hidden if width is more then 1199px, but normal menu is displayed
      //Normal menu is hidden if width is below 1199px, and jquery adds mobile menu
      //Done this way so it can be used with wordpress without any trouble

      $(".menu > ul > li").hover(function(e) {
        if ($(window).width() > 1170) {
          $(this)
            .children("ul")
            .stop(true, false)
            .fadeToggle(300);
          e.preventDefault();
        }
      });
      //If width is more than 1170px dropdowns are displayed on hover

      $(".menu > ul > li").on("click", function() {
        if ($(window).width() <= 1170) {
          $(this)
            .children("ul")
            .fadeToggle(300);
        }
      });
      //If width is less or equal to 1170px dropdowns are displayed on click

      $(".menu-mobile").on("click", function(e) {
        $(".menu > ul").toggleClass("show-on-mobile");
        e.preventDefault();
      });
      //when clicked on mobile-menu, normal menu is shown as a list, classic rwd menu story

      //Nice Select

      $("select").niceSelect();

      /* Quote Carousels */

      $("#owl-sep-1").owlCarousel({
        navigation: false,
        pagination: true,
        transitionStyle: "fade",
        slideSpeed: 500,
        paginationSpeed: 500,
        singleItem: true,
        autoPlay: 5000
      });

      /* Gallery Carousels */

      $("#owl-sep-2").owlCarousel({
        navigation: false,
        pagination: false,
        slideSpeed: 500,
        paginationSpeed: 500,
        items: 7,
        itemsDesktop: [1000, 4],
        itemsDesktopSmall: [900, 3],
        itemsTablet: [600, 2],
        itemsMobile: false,
        autoPlay: 5000
      });

      $("#owl-sep-20").owlCarousel({
        navigation: false,
        pagination: false,
        transitionStyle: "fade",
        slideSpeed: 500,
        paginationSpeed: 500,
        singleItem: true,
        autoPlay: 5000,
        items: 4,

      });

      //Rooms Carousel

      var sync1 = $("#rooms-sync1");
      var sync2 = $("#rooms-sync2");

      sync1.owlCarousel({
        singleItem: true,
        slideSpeed: 400,
        transitionStyle: "goDown",
        pagination: false,
        autoPlay: 6000,
        afterAction: syncPosition
      });
      (function($) {
        var owl = $("#rooms-sync1");
        owl.owlCarousel();

        // Custom Navigation Events
        $(".next-rooms-sync-1").on("click", function() {
          owl.trigger("owl.next");
        });
        $(".prev-rooms-sync-1").on("click", function() {
          owl.trigger("owl.prev");
        });
      })(jQuery);

      sync2.owlCarousel({
        items: 5,
        itemsDesktop: [1199, 4],
        itemsDesktopSmall: [979, 3],
        itemsTablet: [768, 3],
        itemsMobile: [479, 2],
        pagination: false,
        responsiveRefreshRate: 100,
        afterInit: function(el) {
          el.find(".owl-item")
            .eq(0)
            .addClass("synced");
        }
      });

      function syncPosition(el) {
        var current = this.currentItem;
        $("#rooms-sync2")
          .find(".owl-item")
          .removeClass("synced")
          .eq(current)
          .addClass("synced");
        if ($("#rooms-sync2").data("owlCarousel") !== undefined) {
          center(current);
        }
      }

      $("#rooms-sync2").on("click", ".owl-item", function(e) {
        e.preventDefault();
        var number = $(this).data("owlItem");
        sync1.trigger("owl.goTo", number);
      });

      function center(number) {
        var sync2visible = sync2.data("owlCarousel").owl.visibleItems;
        var num = number;
        var found = false;
        for (var i in sync2visible) {
          if (num === sync2visible[i]) {
            var found = true;
          }
        }

        if (found === false) {
          if (num > sync2visible[sync2visible.length - 1]) {
            sync2.trigger("owl.goTo", num - sync2visible.length + 2);
          } else {
            if (num - 1 === -1) {
              num = 0;
            }
            sync2.trigger("owl.goTo", num);
          }
        } else if (num === sync2visible[sync2visible.length - 1]) {
          sync2.trigger("owl.goTo", sync2visible[1]);
        } else if (num === sync2visible[0]) {
          sync2.trigger("owl.goTo", num - 1);
        }
      }

      //Lang Open/Close

      $(".lang-wrap").on("click", function(e) {
        $(".clicked").removeClass("clicked");
        $(this).addClass("clicked");
        e.stopPropagation();
      });
      $(document).on("click", function() {
        $(".clicked").removeClass("clicked");
      });

      /* Video */

      $(".container").fitVids();

      $(".vimeo a,.youtube a").on("click", function(e) {
        e.preventDefault();
        var videoLink = $(this).attr("href");
        var classeV = $(this).parent();
        var PlaceV = $(this).parent();
        if (
          $(this)
            .parent()
            .hasClass("youtube")
        ) {
          $(this)
            .parent()
            .wrapAll('<div class="video-wrapper">');
          $(PlaceV).html(
            '<iframe frameborder="0" height="333" src="' +
              videoLink +
              '?autoplay=1&showinfo=0" title="YouTube video player" width="547"></iframe>'
          );
        } else {
          $(this)
            .parent()
            .wrapAll('<div class="video-wrapper">');
          $(PlaceV).html(
            '<iframe src="' +
              videoLink +
              '?title=0&amp;byline=0&amp;portrait=0&amp;autoplay=1&amp;color=6dc234" width="500" height="281" frameborder="0"></iframe>'
          );
        }
      });

      /* Range slider */

      var range = $(".input-range"),
        value = $(".range-value");

      value.html(range.attr("value") + " $");

      range.on("input", function() {
        value.html(this.value + " $");
      });
    },
    checkAvailabilty: function(event, secondForm = false) {
      event.preventDefault();
      this.loader = true;
      // this.$router.push('/booking-form');
      if (secondForm) {
        this.userQuery.checkIn = $("#start-date").val();
        this.userQuery.checkOut = $("#end-date").val();
        this.userQuery.guests = parseInt($("#maxGuests").val());
      } else {
        this.userQuery.checkIn = $("#start-date-1").val();
        this.userQuery.checkOut = $("#end-date-1").val();
        this.userQuery.guests =
          parseInt($("#adults").val());
      }

      if (this.validateQuery(this.userQuery)) {

        this.$http
          .post(Constants.API_SEARCH_URL, this.userQuery)
          .then(response => {
            console.log(response.data);
            localStorage.queryData = JSON.stringify(this.userQuery);
            localStorage.rooms = JSON.stringify(response.data.result);
            this.$router.push("rooms");
          })
          .catch(function(error) {
            if (error.response) {
              this.loader = false;
              var message = "Unable to complete request.";
              alert(message);
            }
          });
      } else {
        this.loader = false;
        alert("Unable to complete request, Please Fill the form correctly ");
      }

    },

    validateQuery(query) {
      if (
        query.checkIn != "" &&
        query.checkOut != "" &&
        query.guests != 0 &&
        query.checkOut != query.checkIn &&
        isNaN(query.guests) != true
      ) {
        return true;
      }

      return false;
    },

    bookNow(event){
      event.preventDefault();
      this.$router.push('/booking-form');
    },

  },
  watch: {
    $route(to, from) {
      // react to route changes

      this.initInputs();
    }
  }
  // components: {
  //   headerNav
  // }
};
</script>
